<template>
    <div v-if="!toggler(signEdit).isOpen()">
        <div class="flex ai:center">
            <member-avatar :icon-url="item.avatar_url" :short-name="item.name" :type="item.nickname_type"></member-avatar>
            <div class="flex:1 ml:8">
                <div class="f:14 lh:1.4285 color:#333 font:bold inline-flex gap:12 ai:center">
                    {{ nickname }}
                    <span class="bg:#FFE8EB f:12 p:4|8 r:8 font:regular" v-if="isSelf">你的留言</span>
                </div>
                <div class="f:12 lh:1.3333 color:#6F737D">{{ age }}</div>
            </div>
            <template v-if="item.status === 1">
                <div class="ml:12" v-if="isSelf">
                    <button class="inline-flex w:18 h:18 ai:center jc:center rel color:primary" @click.stop="toggler(signEdit).open()" type="button">
                        <i class="fa-solid fa-pen"></i>
                    </button>
                </div>
                <div class="ml:12">
                    <div class="inline-block rel" @click.stop>
                        <div class="abs r:20 bg:white box-shadow:0|0|20|0|#0000001A bottom:50% right:100% mr:10 mb:0 translateY(50%)" v-if="toggler(signCommentMenu).isOpen()">
                            <div class="
                                rel p:16 r:20
                                {content:'';abs;bg:url(image/arrow_tooltip.svg);bottom:50%;right:-6;w:12;h:6;mb:-6;mr:0;transform-origin:50%|0;rotate(-90deg)}::after
                                {b:0;p:0;inline-flex;ai:center;gap:8;white-space:nowrap}>button
                            ">
                                <button class="b:0 p:0 inline-flex ai:center gap:8" @click="emit('delete')" type="button" v-if="isSelf"><i class="fa-solid fa-trash-can"></i>刪除留言</button>
                                <button class="b:0 p:0 inline-flex ai:center gap:8" @click="emit('report')" type="button" v-else>檢舉留言</button>
                            </div>
                        </div>
                        <button class="inline-flex w:18 h:18 ai:center jc:center" @click="toggler(signCommentMenu).toggle(true)" type="button">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                    </div>
                </div>
            </template>
        </div>
        <div class="my:12 f:16 font:normal lh:1.5 color:#333 word-break:break-all" :class="{ 'max-h:72 lines:3': truncated }" v-if="item.status === 1">
            <template v-if="item.target_id">
                <span class="color:primary" v-if="item.parent_id !== item.target_id">B{{ item.parent_floor }}-{{ item.target_floor }}&nbsp;</span>
                <span class="color:primary" v-else>B{{ item.target_floor }}&nbsp;</span>
            </template>
            <span v-html="wrap(item.content)"></span>
            <span class="color:#A9A9A9" v-if="item.modify_time">（已編輯）</span>
        </div>
        <div class="my:12 f:16 font:normal lh:1.5 color:#A9A9A9" v-else>此則留言已被刪除。</div>
        <template v-if="item.status === 1">
            <div class="mb:12" v-if="item.image">
                <img alt="" class="max-h:176 max-w:100% r:8" :src="`files/${item.image}`" />
            </div>
            <div class="mb:12" v-if="item.gif_id">
                <img alt="" class="max-h:176 max-w:100% r:8" :src="`https://i.giphy.com/${item.gif_id}.gif`" />
            </div>
            <div class="mb:12 inline-block" v-if="item.yt">
                <div class="{max-h:176;max-w:100%;r:8}>div">
                    <yt-player :content="item.yt" controls></yt-player>
                </div>
            </div>
        </template>
        <div class="my:12 flex jc:space-between ai:center f:14" v-if="truncated || item.feelings">
            <div>
                <button class="f:14 color:primary" @click="ellipsis = false" type="button" v-if="truncated">展開留言...</button>
            </div>
            <div class="flex gap:2 rel {block}:hover>.abs" v-if="item.feelings">
                <span class="flex {rel}_img {ml:-4}_img+img">
                    <img alt="" class="w:18" :class="`z:${100 - idx}`" :key="idx" :src="`asset/image/feeling-${feeling.category_id}-2.svg`" v-for="(feeling, idx) in item.feelings" />
                </span>
                <span>{{ item.feelingStat.count }}</span>
                <div class="d:none abs z:1 top:100% right:2">
                    <div class="mt:2 r:8 p:6|8 bg:rgba(69,73,83,.95) box-shadow:0|0|6|0|black/.45 color:white {flex;ai:center;gap:4}>div {mt:4}>div+div">
                        <template :key="idx" v-for="idx in 7">
                            <div v-if="item.feelingStat[`count${idx}`]">
                                <span><img alt="" class="w:16" :src="`asset/image/feeling-${idx}-1.svg`" /></span>
                                <span>{{ item.feelingStat[`count${idx}`] }}</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex ai:center jc:space-between">
            <div class="flex gap:16 f:14">
                <div v-if="parent">B{{ parent.floor }}-{{ item.floor }}</div>
                <div v-else>B{{ item.floor }}</div>
                <template v-if="item.status === 1">
                    <div class="inline-flex ai:center gap:4 cursor:pointer rel" @click="unselect(item)" v-if="item.feeling">
                        <img alt="" class="w:20" :src="`asset/image/feeling-${item.feeling}-1.svg`" />
                        <span class="f:12 font:bold color:#FF8A00">{{ feelingDesc[item.feeling] }}</span>
                    </div>
                    <div class="inline-flex ai:center gap:4 cursor:pointer rel" @click.stop v-else>
                        <span class="block w:20 h:20 bg:url(image/icon_emo_smile.svg) cursor:pointer" @click="item.feelingPicker = !item.feelingPicker"></span>
                        <div class="abs z:1 p:8|12 r:100 bg:white box-shadow:0|0|20|0|#0000001A left:-44 bottom:100% mb:8" v-if="item.feelingPicker">
                            <div class="flex ai:center jc:center h:40 {m:4;w:32;opacity:0.6}>img {m:0;w:40;opacity:1}>img:hover">
                                <img alt="" @click="select(item, idx)" :key="idx" :src="`asset/image/feeling-${idx}-1.svg`" :title="feelingDesc[idx]" v-for="idx in 7" />
                            </div>
                        </div>
                    </div>
                    <div class="inline-flex gap:8 ai:center cursor:pointer" @click="emit('toggle')" v-if="item.reply_count">
                        <i class="fa-regular fa-comment"></i>
                        <span v-if="item.toggle">隱藏留言</span>
                        <span v-else>{{ item.reply_count }}則回覆</span>
                    </div>
                </template>
            </div>
            <div v-if="item.status === 1">
                <button class="b:0 p:8|12 font:bold f:14 bg:white r:8" @click="emit('reply')" type="button">回覆</button>
            </div>
        </div>
    </div>
    <div v-else>
        <div>
            <div class="
                flex w:full ai:center p:16 gap:8
                box-shadow:0|0|20|0|#0000001A r:20
                {flex-direction:column;ai:stretch;gap:8}.actived
                {flex}.actived_.username>div:nth-child(2)
                {flex}.actived_.buttons
                {block}.actived_.attachments
                actived
                bg:white
            ">
                <comment-post-field @cancel="toggler(signEdit).close()" :item="item" @update="send"></comment-post-field>
            </div>
        </div>
    </div>
</template>

<script setup>
    const timestamp = useTimestamp();
    const toggleStore = new ToggleStore();
    const userInfo = useUserInfo();

    const signCommentMenu = Symbol("_menu_comment");
    const signEdit = Symbol("editMode");

    const props = defineProps({
        item: { required: true, type: Object },
        parent: { type: Object }
    });

    const feelingDesc = { 1: "同意", 2: "愛心", 3: "懷疑", 4: "驚訝", 5: "生氣", 6: "哭泣", 7: "加油" };

    const ellipsis = ref(true);
    const isSelf = (props.item.member_id == userInfo.id) ? true : false;
    const pattern = /\b(https?:\/\/[-\w+&@#\/%?=~|!:,.;]*[-\w+&@#\/%=~|])/g;

    const age = computed(() => {
        let value = timestamp.now - props.item.time;
        if (value < 60) {
            return `${value} 秒`;
        }
        value = parseInt(value / 60);
        if (value < 60) {
            return `${value} 分鐘`;
        }
        value = parseInt(value / 60);
        if (value < 24) {
            return `${value} 小時`;
        }
        value = parseInt(value / 24);
        if (value < 30) {
            return `${value} 天`;
        }
        value = parseInt(value / 30);
        if (value < 12) {
            return `${value} 個月`;
        }
        value = parseInt(value / 12);
        return `${value} 年`;
    });

    const nickname = computed(() => {
        switch (props.item.nickname_type) {
            case 1:
                return props.item.college_name;
            case 2:
                return props.item.college2_name;
            case 3:
                return props.item.name;
            case 4:
                return props.item.nickname;
            case 5:
                return props.item.college3_name;
        }
    });

    const truncated = computed(() => {
        return ellipsis.value && props.item.content?.length > 120;
    });

    const emit = defineEmits(["delete", "reply", "report", "toggle"]);

    const select = (item, category) => {
        item.feelingPicker = false;

        api("api/comment/feeling/save", { id: item.id, category_id: category }).done((res) => {
            if (res.success) {
                item.feeling = category;
                item.feelingStat = res.feelingStat;
                item.feelings = res.feelings;
            }
        });
    };

    const send = (data) => {
        data.id = props.item.id;

        api("api/comment/save", data).done((res) => {
            if (res.success) {
                props.item.image = res.data.image;
                props.item.gif_id = res.data.gif_id;
                props.item.yt_id = res.data.yt_id;
                props.item.yt = res.data.yt;
                props.item.content = res.data.content;
                props.item.modify_time = res.data.modify_time;

                toggler(signEdit).close();
            }
        });
    }

    const toggler = (name) => {
        return toggleStore.toggler(name);
    };

    const unselect = (item) => {
        api("api/comment/feeling/remove", { id: item.id }).done((res) => {
            if (res.success) {
                item.feeling = null;
                item.feelingStat = res.feelingStat;
                item.feelings = res.feelings;
            }
        });
    };

    const wrap = (text) => {
        return text?.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(pattern, "<a href=\"$1\" target=\"_blank\">$1</a>");
    };
</script>
